module.exports = __webpack_public_path__ + "static/media/showchart.a0537c44.svg";